import React from 'react';
import { OptionItem } from 'types';
import ListBox from 'carbon-components-react/lib/components/ListBox';

const ResultsBox: React.FC<Props> = (props) => {
  const { items, onItemClick, id } = props;

  return (
    <div className={`bx--list-box__wrapper`}>
      <ListBox className="bx--combo-box" isOpen={true}>
        <ListBox.Menu
          id={`${id}-list-menu`}
          className={'search-auto-suggest-list-menu'}
        >
          {items.map((item: OptionItem, inx: number) => {
            return (
              <ListBox.MenuItem
                key={inx}
                onClick={() =>
                  typeof onItemClick === 'function' && onItemClick(item)
                }
              >
                {item.label}
              </ListBox.MenuItem>
            );
          })}
        </ListBox.Menu>
      </ListBox>
    </div>
  );
};

type Props = {
  id: string;
  items: OptionItem[];
  onItemClick: Function;
};

export default ResultsBox;
